import { render, staticRenderFns } from "./ListTurmas.vue?vue&type=template&id=131bab24&"
import script from "./ListTurmas.vue?vue&type=script&lang=js&"
export * from "./ListTurmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports